export const MenuItems = [
    {
        title : "Project",
        url : "/project",
        cName : "nav-links"
    },
    {
        title : "Wet Lab",
        url : "/wetlab",
        cName : "nav-links"
    },
    {
        title : "Dry Lab",
        url : "/drylab",
        cName : "nav-links", 
    },
    {
        title : "Human Practices",
        url : "/humanpractices",
        cName : "nav-links"
    },
    {
        title : "Team",
        url : "/team",
        cName : "nav-links"
    }
]

export const ProjectItems=[
    {
        id: 1,
        title: "Description",
        path: "/description",
        cName: "submenu-item"
    },
    {
        id: 2,
        title: "Contribution",
        path: "/contribution",
        cName: "submenu-item"
    },
]

export const DryLabItems=[
    {
        id: 1,
        title: "Model",
        path: "/model",
        cName: "submenu-item"
    },
]

export const TeamItems=[
    {
        id: 1,
        title: "Members",
        path: "/members",
        cName: "submenu-item",
    },
    {
        id: 2,
        title: "Attributions",
        path: "/attributions",
        cName: "submenu-item"
         },
    {
        id: 3,
        title: "Sponsors",
        path: "/sponsors",
        cName: "submenu-item"
    },
]

export const WetLabItems=[
    {
        id: 1,
        title: "Engineering",
        path: "/engineering",
        cName: "submenu-item"
    },
    {
        id: 2,
        title: "Experiments",
        path: "/experiments",
        cName: "submenu-item"
    },
    {
        id: 3,
        title: "Results",
        path: "/results",
        cName: "submenu-item"
    },
    {
        id: 4,
        title: "Implementation",
        path: "/implementation",
        cName: "submenu-item"
    },
];

export const HumanPracticesItems=[
    {
        id: 1,
        title: "IHP",
        path: "/human-practices",
        cName: "submenu-item"
    },
    {
        id: 2,
        title: "Education",
        path: "/education",
        cName: "submenu-item"
    },
    {
        id: 3,
        title: "Collaborations",
        path: "/collaborations",
        cName: "submenu-item"
    },
];